import type { ComponentProps } from 'react'

import type { ImageFile } from '../../../../../utils/hooks/useOptimizedProductImages'

import { ProductImageCommon } from './ProductImageCommon'

type ProductImageProps = {
  image: ImageFile
}

export const ProductImage = ({
  image,
  ...props
}: Omit<ComponentProps<typeof ProductImageCommon>, 'src'> &
  ProductImageProps) => <ProductImageCommon src={image.src} {...props} />
